import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import '@/index.css'
import { initNativeChrome, isNativeApp } from '@/lib/native'

const container = document.getElementById('root')
if (!container) throw new Error('Не знайдено кореневий елемент #root')

void initNativeChrome()

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

if (import.meta.env.PROD && !isNativeApp() && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js')
  })
}
